import { useRouter } from 'next/navigation';
import { CustomerType, EnergyType } from '@energy-retailer/constants';
import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';

export const useConditionallyShowCrossSell = () => {
  const {
    property: { customerType },
    electricityChecked,
    electricityAvailable,
    electricityPlanSlug,
    gasChecked,
    gasAvailable,
    gasPlanSlug,
    steps,
  } = useJoinFormStore();
  const router = useRouter();
  const hasPlanSelected = Boolean(electricityPlanSlug) || Boolean(gasPlanSlug);

  /**
   * This function must execute before a function that updates any of the store dependencies
   */
  const conditionallyShowCrossSell = (energyType: EnergyType) => {
    if (steps.length === 1) {
      return false;
    }

    if (hasPlanSelected && customerType === CustomerType.Business) {
      return router.push('/sign-up/details');
    }

    if (hasPlanSelected && customerType === CustomerType.Residential) {
      if (
        energyType === EnergyType.Gas &&
        electricityChecked && // electricity is "currently" checked
        gasAvailable // gas is available
      ) {
        return router.push(`/modals/gas-cross-sell`, { scroll: false });
      } else if (
        energyType === EnergyType.Electricity &&
        gasChecked && // gas is "currently" checked
        electricityAvailable
      ) {
        return router.push('/modals/electricity-cross-sell', { scroll: false });
      }
      return false;
    }
    return false;
  };

  return {
    conditionallyShowCrossSell,
  };
};
